/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import e from "../core/Error.js";
import { c as t, f as n, j as o, g as r, i } from "./vec3.js";
import { c as s } from "./vec3f64.js";
import { canProjectToWGS84ComparableLonLat as l } from "../geometry/projection.js";
import { containsPoint as a, containsPointWithMargin as c, fromExtent as u, create as f } from "../geometry/support/aaBoundingRect.js";
import { maxRootTiles as m } from "../views/3d/terrain/TerrainConst.js";
import { getMissingTileInfoError as h, TilingScheme as p } from "../views/3d/terrain/TilingScheme.js";
const g = s(),
  d = s(),
  M = s(),
  x = s();
function S(e, t, n = 0) {
  const o = e.extent;
  if (null == o) return !1;
  if (0 === n) return a(o, t);
  const r = Math.min(o[2] - o[0], o[3] - o[1]);
  return c(o, t, n * r);
}
function j(e, s, l, a) {
  t(g, l), g[a] = s[a];
  const c = n(g, g, s),
    u = n(d, e, s),
    f = o(u, c),
    m = o(c, c);
  let h;
  h = f <= 0 ? s : m <= f ? l : r(g, s, i(c, c, f / m));
  const p = n(g, e, h);
  return Math.PI / 2 - Math.atan(p[2] / Math.sqrt(p[0] * p[0] + p[1] * p[1]));
}
function v(e, t, n) {
  const o = e.extent;
  if (null == o) return 0;
  M[0] = o[0], M[1] = o[1], M[2] = n, x[0] = o[2], x[1] = o[3], x[2] = n;
  let r = 1 / 0,
    i = 1 / 0;
  return t[0] < M[0] ? r = j(t, M, x, 0) : t[0] > x[0] && (r = j(t, x, M, 0)), t[1] < M[1] ? i = j(t, M, x, 1) : t[1] > x[1] && (i = j(t, x, M, 1)), Math.min(r, i);
}
function T(t, n, o) {
  if (null == t) return h();
  if (t.spatialReference.isGeographic && !l(t.spatialReference)) return new e("tilingscheme:local-unsupported-spatial-reference", "The tiling scheme spatial reference is not supported in local scenes");
  const r = p.checkUnsupported(t);
  if (null != r) return r;
  if (null == o) return new e("tilingscheme:extent-not-exist", "The layer does not provide a layer extent.");
  const i = w(t, o);
  if (i) return i;
  const s = t.spatialReference;
  return null == n || s.equals(n) || n.isWGS84 && s.isWebMercator ? null : new e("tilingscheme:spatial-reference-mismatch", "The tiling scheme does not match the spatial reference of the local scene");
}
function w(t, n) {
  const o = t.lods,
    r = o[0].resolution * 2 ** o[0].level,
    i = [r * t.size[0], r * t.size[1]],
    s = [t.origin.x, t.origin.y],
    l = u(n),
    a = f();
  p.computeRowColExtent(l, i, s, a);
  const c = (a[2] - a[0]) * (a[3] - a[1]);
  if (c > m) {
    const n = o[0].scale * 2 ** o[0].level;
    let i = Math.max((l[3] - l[1]) / t.size[1], (l[2] - l[0]) / t.size[0]) * n / r;
    const s = Math.floor(Math.log(i) / Math.log(10));
    return i = Math.ceil(i / 10 ** s) * 10 ** s, new e("tilingscheme:too-many-root-tiles", "Scale of level 0 of the tiling scheme (1:" + Math.floor(n).toLocaleString() + ") is too large for the layer's extent. Suggested scale: 1:" + i.toLocaleString() + ".", {
      level0Scale: n,
      suggestedLevel0Scale: i,
      requiredNumRootTiles: c,
      allowedNumRootTiles: m
    });
  }
  return null;
}
const y = Object.freeze(Object.defineProperty({
  __proto__: null,
  checkIfTileInfoSupportedForViewSR: T,
  isInsideExtent: S,
  tiltToExtentEdge: v
}, Symbol.toStringTag, {
  value: "Module"
}));
export { v as a, T as c, S as i, y as t };